export default __webpack_public_path__ + "static/media/binance-chain-logo.38742372.svg";